import React from 'react';
import QRCode from 'qrcode.react';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import FontAwesome from 'react-fontawesome';
import { Row, Col, Container } from 'reactstrap';

import { Field, reduxForm } from 'redux-form/immutable';
import { FORM_GRUPO } from 'modules/forms/formConstants';
import { TextFieldF, ToggleFieldF } from 'modules/forms/component';
import * as validations from 'modules/forms/validations';

import * as gruposActions from 'modules/grupos/action';
import * as generalActions from 'modules/general/action';
import * as abonadosActions from 'modules/abonados/action';
import { CancelarButtonC } from 'modules/general/component';
import { checkPermissions } from 'core/generalFunctions';

class Add extends React.Component {
  constructor(props) {
    super(props);
    this.searchUser = {};
    this.routerWillLeave = this.routerWillLeave.bind(this);
  }
  routerWillLeave() {
    if (!this.props.pristine && !this.props.submitSucceeded) return 'El formulario tiene cambios,  ¿Está seguro de querer salir?';
  }
  componentDidMount() {
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
    const {
      dispatch,
      params: { grupoId },
    } = this.props;
    if (grupoId === 'new') dispatch(generalActions.dashboard_changeTitle('AGREGAR GRUPO'));
    else {
      dispatch(generalActions.dashboard_changeTitle('MODIFICAR GRUPO'));
      dispatch(gruposActions.getById(grupoId));
    }
  }
  componentWillUnmount = () => this.props.dispatch(gruposActions.clear('grupo'));
  submitForm = data => {
    data = data.toJS();
    if (this.props.params.grupoId !== 'new') data.grupoId = this.props.params.grupoId;
    this.props.dispatch(gruposActions.set(data));
  };
  buscarUsuarios = e => {
    if (e.target.value.length > 3) this.props.dispatch(abonadosActions.get(e.target.value));
    else this.props.dispatch(abonadosActions.clear('lista'));
  };

  addUserToGroup = usuarioId => {
    const {
      params: { grupoId },
    } = this.props;

    this.props.dispatch(gruposActions.modificarUsuarios(usuarioId, grupoId));
  };

  resetSearch = () => {
    this.props.dispatch(abonadosActions.clear('lista'));
    if (this.searchUser && this.searchUser.getInputNode) {
      this.searchUser.getInputNode().value = '';
    }
  };

  deleteUsuario = (usuarioId, grupoId) => this.props.dispatch(gruposActions.deleteUsuario(usuarioId, grupoId));

  render() {
    const {
      usuariosGrupo,
      invalid,
      pristine,
      usuariosList,
      codigoGrupo,
      params: { grupoId },
    } = this.props;
    return (
      <Container fluid={true}>
        <form>
          <Row>
            <Col md={{ size: 4, offset: 1 }}>
              <MaterialUI.Paper zDepth={2} className="padding">
                <MaterialUI.Tabs>
                  <MaterialUI.Tab label="Datos del grupo">
                    <div className="p-lr-10">
                      <Field
                        name={'nombre'}
                        component={TextFieldF}
                        inputProps={{
                          hintText: 'Nombre',
                          floatingLabelText: 'Ingrese el nombre',
                          className: 'capitalize',
                          fullWidth: true,
                          autoFocus: true,
                        }}
                        validate={[validations.minLength3, validations.maxLength50]}
                      />
                    </div>
                    <div className="p10">
                      <Field
                        name="necesitaAprobacion"
                        component={ToggleFieldF}
                        inputProps={{
                          label: 'Solicitar aprobación para ingresar al grupo',
                        }}
                      />
                    </div>
                    <MaterialUI.Divider />
                    {codigoGrupo && (
                      <div className="p10">
                        <p className="bolder"> Codigo: {codigoGrupo} </p>
                        <div className="mt-10">
                          <QRCode size={150} renderAs={'svg'} includeMargin={false} value={'https://jaits.app/r?codigo=' + codigoGrupo} />
                        </div>
                      </div>
                    )}
                    <div className="p10">
                      <MaterialUI.RaisedButton
                        onClick={this.props.handleSubmit(this.submitForm)}
                        label="GUARDAR"
                        primary={true}
                        disabled={invalid || pristine || !checkPermissions(['admin', 'devAdmin', 'administrador_grupos'])}
                        className="fullWidthComponent noPadding m-tb-20 "
                      />
                    </div>
                  </MaterialUI.Tab>
                </MaterialUI.Tabs>
              </MaterialUI.Paper>
            </Col>
            <Col md={{ size: 6 }}>
              <MaterialUI.Paper zDepth={2} className="padding">
                <MaterialUI.Tabs>
                  <MaterialUI.Tab label="Usuarios del grupo">
                    <Row className="p-lr-10">
                      <Col md="12">
                        <Row style={styles.findContainer}>
                          <Col md={1} className="textCenter">
                            <FontAwesome name="search" className="pt-30" size="2x" />
                          </Col>
                          <Col md={9}>
                            <MaterialUI.TextField
                              fullWidth={true}
                              disabled={grupoId === 'new'}
                              name="queryAbonado"
                              floatingLabelText="Buscar"
                              onChange={this.buscarUsuarios}
                              ref={ref => {
                                this.searchUser = ref;
                              }}
                              hintText="Nombre, apellido, DNI o email"
                              errorText={grupoId === 'new' && 'Debe crear el grupo presionando en guardar antes de agregar usuarios.'}
                              errorStyle={styles.errAddUserNewGroup}
                              disabled={this.props.loading}
                            />
                          </Col>
                          {grupoId !== 'new' && (
                            <Col md={1} style={styles.trashIconSearchContainer}>
                              <MaterialUI.FlatButton style={styles.trashIconSearch} icon={<FontAwesome className="iconBar red" name="trash" />} onTouchTap={this.resetSearch} className="listIcon" />
                            </Col>
                          )}
                        </Row>
                      </Col>
                      {!usuariosList.size && (
                        <Col md="12" className="pt-30">
                          <MaterialUI.List className="noPadding dividerList">
                            {usuariosGrupo &&
                              usuariosGrupo.map(usuario => {
                                let label = usuario.get('nombre') + ' ' + usuario.get('apellido');
                                if (usuario.get('documento')) label = usuario.get('documento') + ' - ' + label;
                                if (usuario.getIn(['_usuarioEmpresa', 'fav'])) label += ' - ★';
                                return (
                                  <MaterialUI.ListItem
                                    key={'ugrupo_' + usuario.get('id')}
                                    primaryText={label}
                                    rightIcon={
                                      <MaterialUI.FlatButton
                                        icon={<FontAwesome name={'trash'} className={'iconBar red'} />}
                                        onTouchTap={() => this.deleteUsuario(usuario.get('id'), grupoId)}
                                        className="listIcon"
                                      />
                                    }
                                  />
                                );
                              })}
                          </MaterialUI.List>
                        </Col>
                      )}
                      <MaterialUI.Divider />
                      <Col md="12" className="pt-30">
                        <MaterialUI.List className="noPadding dividerList">
                          {usuariosList &&
                            usuariosList.map(usuario => {
                              const usuarioYaSeleccionado = usuariosGrupo && usuariosGrupo.find(user => user.get('id') === usuario.get('id'));
                              let label = usuario.get('nombre') + ' ' + usuario.get('apellido');
                              if (usuario.get('documento')) label = usuario.get('documento') + ' - ' + label;
                              if (usuario.getIn(['_usuarioEmpresa', 'fav'])) label += ' - ★';
                              return (
                                <div key={usuario.get('id')}>
                                  <MaterialUI.Divider className="mb-10" />
                                  <MaterialUI.ListItem
                                    primaryText={label}
                                    rightIcon={
                                      <MaterialUI.FlatButton
                                        disabled={Boolean(usuarioYaSeleccionado)}
                                        icon={<FontAwesome name={usuarioYaSeleccionado ? 'check' : 'plus'} className={'iconBar green'} />}
                                        onTouchTap={() => this.addUserToGroup(usuario.get('id'))}
                                        className="listIcon"
                                      />
                                    }
                                  />
                                </div>
                              );
                            })}
                        </MaterialUI.List>
                      </Col>
                    </Row>
                  </MaterialUI.Tab>
                </MaterialUI.Tabs>
              </MaterialUI.Paper>
            </Col>
          </Row>
        </form>
        <CancelarButtonC className="m-tb-20" dispatch={this.props.dispatch} />
      </Container>
    );
  }
}

const styles = {
  trashIconSearch: {
    minWidth: 40,
  },
  trashIconSearchContainer: {
    paddingTop: 30,
  },
  errAddUserNewGroup: {
    color: 'gray',
  },
  findContainer: {
    alignItems: 'center',
  },
};

Add = reduxForm({ form: FORM_GRUPO, enableReinitialize: true })(Add);
Add = connect(store => ({
  loading: store.getIn(['general', 'loading']),
  usuariosGrupo: store.getIn(['grupos', 'grupo', '_usuarios']),
  usuariosList: store.getIn(['abonados', 'lista', 0]) || [],
  codigoGrupo: store.getIn(['grupos', 'grupo', '_codigo', 'codigo']),
  initialValues: {
    necesitaAprobacion: store.getIn(['grupos', 'grupo', 'necesitaAprobacion']),
    nombre: store.getIn(['grupos', 'grupo', 'nombre']),
    usuarios: store.getIn(['grupos', 'grupo', '_usuarios']),
  },
}))(Add);

export default Add;



// WEBPACK FOOTER //
// src/modules/grupos/components/add.js